import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { AttemptService } from '../../../exams/services/attempt.service';
import { UserService } from 'src/app/services/user/user-service/user.service';
import { LocalStorageService } from 'src/app/services/local-storage-service/local-storage.service';
import { WardsService } from 'src/app/services/wards-service/wards.service';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { Student } from 'src/app/models/student';
import { UserContext } from 'src/app/models/user-context';
import { AppSettings } from 'src/app/utils/app-settings';
import { ExamTestService } from '../../../exams/services/exam-test.service';
import { OnlineExamSchedule } from '../../../dashboard/models/online-exam-schedule';
import { Subject } from 'rxjs';
import { QuestionPaperAttemptContext } from 'form-builder';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { ExamBackendService } from "../../services/exam-backend.service";
import { FormBuilderBackendService } from 'form-builder';
import { FileUploadSessionService } from 'file-upload-session';
import { AnswerFileUploadService } from '../../services/answer-file-upload.service';

@Component({
  selector: 'app-attempt-online-exam',
  templateUrl: './attempt-online-exam.component.html',
  styleUrls: ['./attempt-online-exam.component.scss'],
  providers: [{ provide: FormBuilderBackendService, useClass: ExamBackendService },
  {provide: FileUploadSessionService, useClass: AnswerFileUploadService}],
  encapsulation: ViewEncapsulation.None
})
export class AttemptOnlineExamComponent extends ComponentBase implements OnInit {

  constructor(private route: ActivatedRoute
    , private attemptService: AttemptService
    , private userService: UserService
    , private localStorageService: LocalStorageService
    , private wardsService: WardsService
    , private examTestService: ExamTestService
    , private routingService: RoutingService) {
    super();
  }

  loading: boolean = true;
  errors: Error[] = [];
  studentInfo: Student;
  attemptId: number;
  selectedExamTest: OnlineExamSchedule;
  timeDiff: number;
  showSaveConfirm: boolean = false;
  emittedEvent: QuestionPaperAttemptContext;
  private dateSubject = new Subject<string>();

  ngOnInit() {
    let sub = this.route.params.pipe(
      switchMap(params => {
        return this.examTestService.getExamTestById(+params['id'])
      })
    ).subscribe(res => {
      if (res.body) {
        if(new Date(res.body.to_time).getTime() <=  new Date(res.headers.get('date')).getTime() 
          || res.body.action == 3){
          this.redirectToSuccessPage();
        }
        else{
          this.selectedExamTest = res.body;
          this.dateSubject.next(res.headers.get('date'));
        }
      }
    })
    this.addSubscription(sub);

    let sub2 = this.route.params.subscribe(params => {
      this.attemptId = +params['attemptId'];
    })
    this.addSubscription(sub2);

    let sub3 = this.userService.getLoggedInUser()
      .subscribe(user => {
        this.loading = false;
        if (!user.students || user.students.length == 0) {
          window.location.href = "/";
          return;
        }
        let user_context: UserContext = this.localStorageService.getItem(AppSettings.LocalStorageUserContextKey);
        if (!user_context) {
          window.location.href = "/";
          return;
        }
        if (user_context && user.person.person_id == user_context.person_id) {
          this.studentInfo = user.students.find(o => o.student_id == user_context.student_id);
        }
        if (!this.studentInfo) {
          window.location.href = "/";
          return;
        }
        else {
          this.wardsService.setWard(this.studentInfo);
        }
      });
    this.addSubscription(sub3);

    let sub4 = this.dateSubject.subscribe(res => {
      this.timeDiff = new Date(this.selectedExamTest.to_time).getTime() - new Date(res).getTime();
    })
    this.addSubscription(sub4);
  }

  onSave(event: boolean){
    let sub = this.attemptService.completeAttempt(this.attemptId)
    .subscribe(_ => {
      this.redirectToSuccessPage();
    },
    err => {
      this.errors.push({ "name": err.code, "message": err.message });
    });
    this.addSubscription(sub);
  }

  redirectToSuccessPage() {
    let route = new PrifactRoute();
    route.primary_command = ['online-exam-success'];
    route.clear_history = true;
    this.routingService.navigate(route);
  }

}
